// Well lists for achievement checks (perf). events.tickAchievements runs every check inside withAchBatch(), so the
// ~35 checks share one Object.values/filter per tick instead of building their own. Outside a batch (UI) every call
// is fresh. Shared arrays: checks must not mutate them (filter/some/every only).
let BATCH = null;
export function withAchBatch(state, fn) {
  BATCH = { s: state, all: null, own: null };
  try { return fn(); } finally { BATCH = null; }
}
const values = (s) => Object.values(s?.wells ?? {});
export const allWells = (s) => (BATCH && BATCH.s === s ? (BATCH.all ??= values(s)) : values(s));
// Quick Start wells don't count (polish G7)
export const ownWells = (s) => (BATCH && BATCH.s === s ? (BATCH.own ??= allWells(s).filter((w) => !w.inherited)) : values(s).filter((w) => !w.inherited));
